import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { ErstelleAufgabeDialogComponent } from './erstelle-aufgabe-dialog/erstelle-aufgabe-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { BatchVorgangDialogComponent } from './batch-vorgang-dialog/batch-vorgang-dialog.component';
import { JsonPipe } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class AufgabeDialogService {
    private dialog = inject(MatDialog);


    private aufgabeChanged$ = new BehaviorSubject<boolean>(true);

    public observeAufgabeChanged(): Observable<boolean> {
        return this.aufgabeChanged$.asObservable();
    }

    public openDetail() {
        const dialogRef = this.dialog.open(ErstelleAufgabeDialogComponent, {
            disableClose: true,
            panelClass: 'ufla-detail-dialog-container',
        });

        firstValueFrom(dialogRef.afterClosed()).then(ret => {
            console.log('ret: ' + new JsonPipe().transform(ret));
            this.aufgabeChanged$.next(true);
        });
    }

    public openGesamtlastOrAbwurfpunkteDetail() {
        const dialogRef = this.dialog.open(BatchVorgangDialogComponent, {
            disableClose: true,
            panelClass: 'ufla-detail-dialog-container',
        });

        firstValueFrom(dialogRef.afterClosed()).then(() => this.aufgabeChanged$.next(true));
    }
}
